import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  allRoles: null,
  addRole: null,
}
const getters = {
  role(roleId) {
    const url = `/Permissions/group/${roleId}`
    return axios.get(url)
  },
  allRoles() {
    const url = '/Permissions/group'
    return axios.get(url)
  },
  allResources() {
    const url = '/Permissions/resource'
    return axios.get(url)
  },
  allResourceModules() {
    const url = '/Permissions/module'
    return axios.get(url)
  },
}
const saves = {
  addRole(roleData) {
    const url = '/Permissions/group'
    return axios.post(url, roleData)
  },
  updateRole(roleData) {
    const url = `/Permissions/group/${roleData.id}`
    return axios.put(url, roleData)
  },
}

export default class RoleManagementServices extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }
}
